(function () {
  'use strict';

  var ROOT_SELECTOR = 'main[data-template="product.laptop-stand"]';
  var OPTIONS_SELECTOR = '[data-laptop-stand-options]';
  var OPTION_INPUT_SELECTOR = 'input[data-option-name="Configuration"][data-variant-id]';
  var initialized = false;

  function getRoot() {
    return document.querySelector(ROOT_SELECTOR);
  }

  function getOptions(root) {
    return root && root.querySelector(OPTIONS_SELECTOR);
  }

  function getPicker(root) {
    return root && root.querySelector('variant-picker');
  }

  function getInputs(picker) {
    return picker ? Array.prototype.slice.call(picker.querySelectorAll(OPTION_INPUT_SELECTOR)) : [];
  }

  function splitValue(value) {
    var parts = (value || '').split(/\s*\/\s*/);
    return {
      color: parts[0] || '',
      configuration: parts[1] || ''
    };
  }

  function findInput(picker, color, configuration) {
    var expected = color + ' / ' + configuration;
    return getInputs(picker).find(function (input) {
      return input.value === expected && !input.disabled;
    });
  }

  function selectedValue(picker) {
    var inputs = getInputs(picker);
    var selected = inputs.find(function (input) { return input.checked; }) || inputs[0];
    return selected ? splitValue(selected.value) : null;
  }

  function displayConfigurationLabel(configuration) {
    if (configuration === 'Single') return '1 Slot';
    if (configuration === 'Dual') return '2 Slots';
    return configuration || '';
  }

  function sync(root, options, picker) {
    var selected = selectedValue(picker);
    if (!selected) return false;

    options.querySelectorAll('[data-color]').forEach(function (button) {
      button.setAttribute('aria-pressed', button.getAttribute('data-color') === selected.color ? 'true' : 'false');
    });
    options.querySelectorAll('[data-configuration]').forEach(function (button) {
      var configuration = button.getAttribute('data-configuration');
      var available = !!findInput(picker, selected.color, configuration);
      button.disabled = !available;
      button.setAttribute('aria-pressed', configuration === selected.configuration ? 'true' : 'false');
    });
    var colorLabel = options.querySelector('[data-laptop-color-label]');
    var configurationLabel = options.querySelector('[data-laptop-configuration-label]');
    if (colorLabel) colorLabel.textContent = selected.color;
    if (configurationLabel) configurationLabel.textContent = displayConfigurationLabel(selected.configuration);

    options.classList.add('is-ready');
    root.classList.add('dm-laptop-stand-options-ready');
    return true;
  }

  function setInfoState(button, open) {
    if (!button) return;
    var tooltip = button.parentElement && button.parentElement.querySelector('[role="tooltip"]');
    button.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (tooltip) tooltip.hidden = !open;
  }

  function closeInfo(options) {
    if (!options) return;
    options.querySelectorAll('[data-laptop-color-info]').forEach(function (button) {
      setInfoState(button, false);
    });
  }

  function select(root, options, picker, button) {
    var selected = selectedValue(picker);
    if (!selected) return;

    var color = button.getAttribute('data-color') || selected.color;
    var configuration = button.getAttribute('data-configuration') || selected.configuration;
    var input = findInput(picker, color, configuration);
    if (!input) return;

    if (!input.checked) input.click();
    sync(root, options, picker);
  }

  function wire(root) {
    var options = getOptions(root);
    var picker = getPicker(root);
    if (!options || !picker) return;
    if (!getInputs(picker).length) return;

    if (!options.dataset.bound) {
      options.dataset.bound = 'true';
      options.addEventListener('click', function (event) {
        var infoButton = event.target.closest('[data-laptop-color-info]');
        if (infoButton) {
          event.preventDefault();
          var willOpen = infoButton.getAttribute('aria-expanded') !== 'true';
          closeInfo(options);
          setInfoState(infoButton, willOpen);
          return;
        }
        var button = event.target.closest('button[data-color], button[data-configuration]');
        if (!button || button.disabled) return;
        event.preventDefault();
        select(root, options, picker, button);
      });
      options.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') {
          closeInfo(options);
          var infoButton = options.querySelector('[data-laptop-color-info]');
          if (infoButton) infoButton.focus();
        }
      });
    }

    sync(root, options, picker);
    if (!picker.dataset.dmLaptopStandObserved) {
      picker.dataset.dmLaptopStandObserved = 'true';
      new MutationObserver(function () {
        sync(root, options, picker);
      }).observe(picker, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'disabled'] });
    }
  }

  function apply() {
    var root = getRoot();
    if (!root) return;
    wire(root);
  }

  function start() {
    if (initialized) return;
    initialized = true;
    apply();
    document.addEventListener('shopify:section:load', apply);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
